import assertNever from "assert-never";
import * as React from "react";
import * as messages from "../../../messages";
import {
  getScheduledVisitEditRequestStatus,
  ScheduledVisitEditRequestStatus,
  ScheduledVisitEditRequestType,
} from "../../../messages/ScheduledVisitEditRequest";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

export interface RequestStatusComponentProps {
  request: messages.ScheduledVisitEditParams;
  children?: React.ReactNode;
}

function getScheduledVisitEditRequestStatusDisplayName(
  status: ScheduledVisitEditRequestStatus
): string {
  switch (status) {
    case ScheduledVisitEditRequestStatus.ACCEPTED: {
      return translate(STRINGS.ACCEPTED);
    }
    case ScheduledVisitEditRequestStatus.REJECTED: {
      return translate(STRINGS.REJECTED);
    }
    case ScheduledVisitEditRequestStatus.PENDING: {
      return translate(STRINGS.PENDING);
    }
    default: {
      return assertNever(status);
    }
  }
}

function getRequestTypeDisplayName(type: ScheduledVisitEditRequestType): string {
  switch (type) {
    case ScheduledVisitEditRequestType.CANCEL: {
      return translate(STRINGS.CANCEL);
    }
    case ScheduledVisitEditRequestType.RESCHEDULE: {
      return translate(STRINGS.RESCHEDULE);
    }
    default: {
      return assertNever(type);
    }
  }
}

export class RequestStatusComponent extends React.Component<RequestStatusComponentProps, {}> {
  render() {
    return (
      <div className="RequestStatusComponent__root">
        {(() => {
          const status = getScheduledVisitEditRequestStatus(this.props.request.response);
          const text =
            getRequestTypeDisplayName(this.props.request.requestParams.type) +
            " " +
            translate(STRINGS.REQUESTED) +
            ": " +
            getScheduledVisitEditRequestStatusDisplayName(status);
          switch (status) {
            case ScheduledVisitEditRequestStatus.ACCEPTED: {
              return (
                <div className="RequestStatusComponent__statusTextAccepted">
                  {text}
                  {this.props.children}
                </div>
              );
            }
            case ScheduledVisitEditRequestStatus.REJECTED: {
              return (
                <div className="RequestStatusComponent__statusTextRejected">
                  {text}
                  {this.props.children}
                </div>
              );
            }
            case ScheduledVisitEditRequestStatus.PENDING: {
              return (
                <div className="RequestStatusComponent__statusTextPending">
                  {text}
                  {this.props.children}
                </div>
              );
            }
            default:
              return assertNever(status);
          }
        })()}
      </div>
    );
  }
}
